"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledContainerText = exports.StyledContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const StyledContainerText = exports.StyledContainerText = _styledComponents.default.span``;
const StyledContainer = exports.StyledContainer = _styledComponents.default.div`
	${({
  hoverColor,
  isHover,
  onClick
}) => {
  return `display: flex;
	justify-content: center;
	align-items: center;
	transition: all 1s;
	cursor: ${onClick ? 'pointer' : ''};
	${StyledContainerText} {
		padding-left: 6px;
        ${isHover && hoverColor ? `
						color: ${hoverColor};
				  ` : ''}
	}`;
}}
`;